import { render, staticRenderFns } from "./c-import-config-popup.vue?vue&type=template&id=183de706"
import script from "./c-import-config-popup.vue?vue&type=script&lang=js"
export * from "./c-import-config-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('183de706')) {
      api.createRecord('183de706', component.options)
    } else {
      api.reload('183de706', component.options)
    }
    module.hot.accept("./c-import-config-popup.vue?vue&type=template&id=183de706", function () {
      api.rerender('183de706', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/mconfigs/views/list/popups/c-import-config-popup.vue"
export default component.exports